import React, { useState, useContext } from "react";
import { useMediaQuery } from "react-responsive";
import Context from "../OriginStoryProvider";

const Handwriting = () => {
	const {
		data: { content },
	} = useContext(Context);

	const isDesktopOrLaptop = useMediaQuery({
		query: `(min-width: 1024px)`,
	});

	const [showPopUp, setShowPopUp] = useState(isDesktopOrLaptop ? false : true);

	const handleMouseEnter = () => {
		if (!isDesktopOrLaptop) return;
		setShowPopUp(true);
	};

	const handleMouseLeave = () => {
		if (!isDesktopOrLaptop) return;
		setShowPopUp(false);
	};

	return (
		<div className="chapter-1__handwriting main-grid">
			<div className="main-grid__margin"></div>
			<div className="main-grid__body">
				<figure
					className="chapter-1__handwriting__img-container"
					onMouseEnter={handleMouseEnter}
					onMouseLeave={handleMouseLeave}
				>
					<div className="aspect-ratio-box">
						<img
							className="chapter-1__handwriting__img"
							srcSet={`${mainScript.assetPath}images/webp/chapter-1/poem-cut-400w.webp 400w, ${mainScript.assetPath}images/webp/chapter-1/poem-cut-600w.webp 600w, ${mainScript.assetPath}images/webp/chapter-1/poem-cut-800w.webp 800w, ${mainScript.assetPath}images/webp/chapter-1/poem-cut-1000w.webp 1000w, ${mainScript.assetPath}images/webp/chapter-1/poem-cut-1200w.webp 1200w, ${mainScript.assetPath}images/webp/chapter-1/poem-cut-1600w.webp 1600w, ${mainScript.assetPath}images/webp/chapter-1/poem-cut-2000w.webp 2000w`}
							sizes="(max-width: 400px) 400px, (max-width: 600px) 600px, (max-width: 800px) 800px, (max-width: 1000px) 1000px, (max-width: 1200px) 1200px, (max-width: 1600px) 1600px, (min-width: 1601px) 2000px"
							src={`${mainScript.assetPath}images/png/poem-cut.png`}
							loading="lazy"
							alt="A hand written poem"
							width="2876"
							height="1304"
						/>
					</div>
					<figcaption
						className="chapter-1__handwriting__caption img-caption"
						dangerouslySetInnerHTML={{
							__html: content.chapters.first.handwriting.caption,
						}}
					></figcaption>
				</figure>
				{showPopUp && (
					<p
						className="chapter-1__handwriting__pop-up"
						dangerouslySetInnerHTML={{
							__html: `&ldquo;${content.chapters.first.handwriting.text}&rdquo;`,
						}}
					></p>
				)}
			</div>
			<div className="main-grid__margin"></div>
		</div>
	);
};

export default Handwriting;
